import React, {useCallback} from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import {makeStyles} from '@material-ui/styles';
import MenuItem from '@material-ui/core/MenuItem';
import {OutlinedSelectProps} from '../../OutlinedSelect';
import Select from '@material-ui/core/Select';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const useStyles = makeStyles({
    root: {
        '&:focus': {
            backgroundColor: '#ffffff',
        },
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
    }
});

interface GridSelectProps extends Partial<OutlinedSelectProps> {
    onGridChange(grid: Grid): void;
    grid: Grid;
}

export default function GridSelect({onGridChange, grid, ...props}: GridSelectProps) {
    const classes = useStyles();

    return <Select
        {...props}
        value={grid}
        onChange={useCallback(event => {
            onGridChange(event.target.value as Grid);
        }, [onGridChange])}
        disableUnderline
        classes={{root: classes.root}}
        IconComponent={() => <ArrowDropDownIcon style={{display: 'none'}} />}
    >
        <MenuItem value='none' dense>
            <ListItemText primary='None' secondary='' />
        </MenuItem>

        <MenuItem value='lng|lat|dd' dense>
            <ListItemText primary='Lat/Lng' secondary='Decimal Degrees' />
        </MenuItem>

        <MenuItem value='lng|lat|dms' dense>
            <ListItemText  primary='Lat/Lng' secondary='Degrees Minutes Seconds' />
        </MenuItem>

        <MenuItem value='utm' dense>
            <ListItemText primary='UTM' secondary='' />
        </MenuItem>

        <MenuItem value='mgrs' dense>
            <ListItemText primary='MGRS' secondary='' />
        </MenuItem>
    </Select>;
}
